import { toastMessages } from 'components/toastMessage/signals.ts';
import { localize } from 'i18n/localize.ts';

const $t = localize();

const BANKID_QUERY_PARAMETER_NAME = 'bankid';
const BANKID_ERROR_QUERY_PARAMETER_NAME = 'error';
const MOJEID_QUERY_PARAMETER_NAME = 'mojeid';
const VERIFICATION_RESULT = {
	DONE: 'done',
	ERROR: 'error',
	INCOMPLETE: 'incomplete',
	MISMATCH: 'mismatch',
} as const;
const BANKID_ERROR = {
	ACCESS_DENIED: 'access_denied',
	EID_NOT_EXIST: 'eid_doesnt_exist',
} as const;

export function processVerificationQuery() {
	const url = new URL(globalThis.window.location.href);
	const bankId = url.searchParams.get(BANKID_QUERY_PARAMETER_NAME);
	const bankIdError = url.searchParams.get(BANKID_ERROR_QUERY_PARAMETER_NAME);
	const mojeId = url.searchParams.get(MOJEID_QUERY_PARAMETER_NAME);

	if (bankId === VERIFICATION_RESULT.DONE) {
		toastMessages.addMessage($t.verification.bankIdStatusSuccess, 'success');
	} else if (bankId === VERIFICATION_RESULT.MISMATCH) {
		toastMessages.addMessage($t.verification.bankIdStatusMismatch, 'error');
	} else if (bankId === VERIFICATION_RESULT.ERROR) {
		if (bankIdError === BANKID_ERROR.ACCESS_DENIED) {
			toastMessages.addMessage($t.verification.bankIdStatusAccessDenied, 'error');
		} else if (bankIdError === BANKID_ERROR.EID_NOT_EXIST) {
			toastMessages.addMessage($t.verification.bankIdStatusEidDoesntExist, 'error');
		} else {
			toastMessages.addMessage($t.verification.bankIdStatusError, 'error');
		}
	}

	if (mojeId === VERIFICATION_RESULT.DONE) {
		toastMessages.addMessage($t.verification.mojeIdStatusSuccess, 'success');
	} else if (mojeId === VERIFICATION_RESULT.MISMATCH) {
		toastMessages.addMessage($t.verification.mojeIdStatusMismatch, 'error');
	} else if (mojeId === VERIFICATION_RESULT.INCOMPLETE) {
		toastMessages.addMessage($t.verification.mojeIdStatusIncomplete, 'error');
	} else if (mojeId === VERIFICATION_RESULT.ERROR) {
		toastMessages.addMessage($t.verification.mojeIdStatusError, 'error');
	}

	if (bankId || mojeId) {
		globalThis.window.history.replaceState(history.state, '', location.pathname);
	}
}
